import React, { FC } from "react";
import { Snackbar } from "@mui/material";

type ToastProps = {
  setShowToast: (showToast: boolean) => void;
  showToast: boolean;
  toastMessage: string;
  error?: boolean;
  "data-testid"?: string;
};

const Toast: FC<ToastProps> = ({
  setShowToast,
  showToast,
  toastMessage,
  error = false,
  "data-testid": testId,
}) => {
  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      open={showToast}
      message={toastMessage}
      autoHideDuration={3000}
      onClose={() => setShowToast(false)}
      ContentProps={{
        sx: { backgroundColor: error ? "red " : "green" },
      }}
      data-testid={testId}
    />
  );
};

export default Toast;
